<template>
    <div class="container bg_fff">
        <breadcrumb :pages="['转诊统计']"></breadcrumb>
        <div class="pl15 pr15 pt15 pb15">
            <referral-search-form2 @search="search" @output="output"></referral-search-form2>
            <div class="mt15">
                <el-table border size="mini" :data="list" :header-cell-style="{backgroundColor:'#fafafa'}" ref="table">
                    <el-table-column label="转诊类型" prop="referralType"></el-table-column>
                    <el-table-column label="统计类型" prop="statisticType"></el-table-column>
                    <el-table-column label="转诊单状态" prop="referralStatusDescription"></el-table-column>
                    <el-table-column label="姓名" prop="patName"></el-table-column>
                    <el-table-column label="性别" prop="patGender" :formatter="_formatterSex"></el-table-column>
                    <el-table-column label="年龄" prop="patAge"></el-table-column>
                    <el-table-column label="转诊申请日期" prop="createTime"  :formatter="_formatterTime"></el-table-column>
                    <el-table-column label="预约日期" prop="hopeTime" :formatter="_formatterTime"></el-table-column>
                    <el-table-column label="申请医院" prop="initHosName"></el-table-column>
                    <el-table-column label="申请医生" prop="initDocName"></el-table-column>
                    <el-table-column label="预约医院" prop="hopeHosName"></el-table-column>
                    <el-table-column label="安排日期" prop="acceptTime" :formatter="_formatterTime"></el-table-column>
                </el-table>
            </div>
            <div class="pt15">
                <el-pagination
                    @current-change="pageChange"
                    :page-size="page.pageSize"
                    :current-page="page.pageNum"
                    layout="total, prev, pager, next, jumper"
                    :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";
  import {referralMixin} from "../../lib/mixins/referral";
  import {referralFormMixin} from "../../lib/mixins/referral-form";
  import ReferralSearchForm2 from "../../components/referral/search-form2";
  import {referralService} from "../../lib/service/referral";
  import {STATISTICS_TYPE} from "../../lib/config";
  import {isEmpty,timeFormat} from "../../lib/utils";
  import XLSX from 'xlsx'

  export default {
    name: "Statistics",
    data() {
      return {
        form: {
          pageNum: 1,
          pageSize: 10
        },
        list: [],
        page: {
          pageNum: 1,
          pageSize: 10,
          total: 5
        }
      }
    },
    computed: {},
    components: {ReferralSearchForm2, Breadcrumb},
    mixins: [referralMixin, referralFormMixin],
    created() {
    },
    mounted() {
      this.getList();
    },
    watch: {
      $route() {
        this.resetFormReferral();
        this.setFormReferralType();
        this.getList();
      }
    },
    methods: {
        _formatterSex(row, column, cellValue){
            return cellValue == 'F' ? '女' : '男'
        },
        _formatterTime(row, column, cellValue){
            if(cellValue == undefined || cellValue == "")return ''
            return timeFormat(cellValue,'%Y-%m-%d %H:%M');
        },
      search(data) {
        this.resetFormReferral();
        this.form = {...this.form, ...data};
        let start = this.form.startTime.substring(0,4)+this.form.startTime.substring(5,7)+this.form.startTime.substring(8,10)
        let end = this.form.endTime.substring(0,4)+this.form.endTime.substring(5,7)+this.form.endTime.substring(8,10)

        if(end<start){
          this.$message.error('请合理选择时间范围！')
          return
        }
        this.getList();
      },
      output() {
        if (this.list.length === 0) return this.$message.error('暂无数据导出');
        const table = this.$refs.table;
        if (!isEmpty(table)) {
          const {columns} = table;
          let data = [], propertys = [...columns].map(r => r.property);
          data.push([...columns].map(r => r.label));
          this.list.forEach(r => {
            let arr = [...propertys].map( (rr) => {
                if (rr == 'patGender') {
                    return r[rr] == 'F' ? '女' : '男'
                }
                if (['createTime', 'hopeTime', 'acceptTime'].indexOf(rr) != -1 && r[rr] != '' && r[rr] != undefined) {
                    return timeFormat(r[rr], '%Y-%m-%d %H:%M');
                }
                return r[rr];
            });
            data.push(arr);
          });
          Log('data', data);
          const ws = XLSX.utils.aoa_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
          XLSX.writeFile(wb, Date.now() + ".xlsx");
        }
      },
      pageChange(page) {
        this.form.pageNum = page;
        this.getList();
      },
      async getList() {
        const {list, page} = await referralService.list(this.form);
        this.list = list;
        // this.list = list.map(r => {
        //   let t = STATISTICS_TYPE.find(r => r.id === this.form.aspectUser);
        //   if (t) r._statistics_type = t.name;
        //   return r;
        // });
        this.page = page;
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
